<template>
  <div>
    <div class="main-content main-content1 font1rem minheight100">
      <!-- one tab -->
      <div class="conatiner-fluid d1" id="DataA">
        <div class="row mt-3">

          <div class="col-sm-12">

            <div class="blockgrid" style="">

              <div class="blockspace" :class="{ 'overuse': customerdata.usercount > licence.usercount }">
                <span>Benutzer<br /><b>{{customerdata.usercount}} / {{licence.usercount}}</b></span>
              </div>
              <div class="blockspace" :class="{ 'overuse': customerdata.projectcount > licence.projectcount }">
                <span>Projekte<br /><b>{{customerdata.projectcount}} / {{licence.projectcount}}</b></span>
              </div>
              <div class="blockspace">
                <span>Archivierte Projekte<br /><b>{{customerdata.projectarchivcount}}</b></span>
              </div>
<!--              <div class="blockspace">-->
<!--                <span>Dokumente<br /><b>{{parseInt(customerdata.crcount) + parseInt(customerdata.reportcount)}}</b></span>-->
<!--              </div>-->
<!--              <div class="blockspace">-->
<!--                <span>Fotos<br /><b>{{customerdata.photocount}}</b></span>-->
<!--              </div>-->
<!--              <div class="blockspace">-->
<!--                <span>Pläne<br /><b>{{customerdata.plancount}}</b></span>-->
<!--              </div>-->

            </div>

          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'dashboard',
  data () {
    return {
      'customerid': '',
      'customerdata': {},
      'area': 'dashboard',
      licence: {}
    }
  },

  mounted () {
    console.log('DASHBOARD MOUNTED')
    this.customerid = this.$route.params.customerid
    this.getcustomerdata();
    this.getCustomerLicences();
    if(this.$route.params.area) {
      this.area = this.$route.params.area
    }
    console.log('customer', this.$route.params.customerid, this)
  },

  methods: {
    async getCustomerLicences() {
      let _this = this

      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken, {
        parameters: [_this.customerid],
        serviceName: "ProjectdocuCustomer",
        methodName: "getcustomerlicences"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
        console.log('LEGTH', response.data.licences, response.data.licences.length)
        if (response.data.licences.length > 0) {
          let licences = response.data.licences
          _this.licence = licences[0]
          console.log('LICENCE',_this.licence)
        }
      }).catch(e => {
        console.log('ERROR EXECUTION')
      });
    },

    async getcustomerdata() {
      let _this = this
      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken, {
        parameters: [_this.$route.params.customerid],
        serviceName: "ProjectdocuCustomer",
        methodName: "getcustomerdata"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
        console.log(response)
        if(response.data == false) {
          // Do Nothing because is not admin!
          this.$router.push('/projects')
        } else {
          _this.customerdata = response.data
          console.log('CUSTOMER_DATA', _this.customerdata)
        }

        console.log('This', _this.isCustomerAdmin, _this.customers)
      }).catch(e => {
        // localStorage.clear()
        this.$router.push('/projects')
      });
    }
  },

  created () {
    console.log('created dashboard')
  }
}

</script>



// WEBPACK FOOTER //
// src/components/customer/components/dashboard.vue